<div class="flex flex-col">
  <!-------------------------------- Table ------------------------------------>
  <div class="overflow-x-auto rounded-t-2xl border border-gray-200"
       [ngClass]="{
        'rounded-b-2xl overflow-y-auto relative ' : pagination == false,
       }"
       [style.height]="heightTable"
  >
    <table class="min-w-full divide-y divide-gray-200 text-sm">
      <thead class="bg-gray-100 text-gray-700 uppercase text-xs">
        <tr>
          <th class="px-4 py-4 text-center">{{ language === 'th' ? "ลําดับ" : "No."}}</th>
          <th class="px-4 py-4 text-center " *ngFor="let hd of headers">{{hd}}</th>
        </tr>
      </thead>

      <tbody class="divide-y divide-gray-100 bg-white">
        <tr *ngFor="let data of pagination ? pagedData : data; let i = index; trackBy: trackByIndex" class="hover:bg-gray-50">
          <!-- continuous index across pages -->
          <td class="px-4 py-4 font-medium text-gray-700 text-center">{{ (currentPage - 1) * pageSize.value + i + 1 }}</td>
          <td class="px-4 py-4 text-center" *ngFor="let col of columns">
            <p *ngIf="col.type !== 'button'">
              {{ 
                col.type === 'date' ? (data[col.column] | date : 'dd/MM/yyyy HH:mm') :data[col.column]
              }}
            </p>
            <button *ngIf="col.type === 'button'"
                    class="w-full px-4 py-2 rounded text-white"
                    [ngClass]="col.btColor"
                    (click)="col.function(data)"
            >
              {{ col.btText }}
            </button>
          </td>
        </tr>

        <!-- empty state -->
        <tr *ngIf="pagedData.length === 0 && pagination">
          <td class="px-4 py-6 text-center text-gray-500" colspan="10">{{ language === 'th' ? "ไม่มีข้อมูล" : "No data"}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-------------------------------- Pagination controls ------------------------------------>
  <div class="flex flex-col md:flex-row items-center justify-between gap-3 border border-gray-200 px-4 py-3 rounded-b-lg relative"
    style="box-shadow: 0px -2px 4px rgba(139, 139, 139, 0.205);"
    *ngIf="pagination"
  >
    <!-- Left: page size -->
  <div class="flex items-center space-x-2 relative w-fit">
    <div class="text-sm text-gray-600 whitespace-nowrap">
      {{ language === 'th' ? "แสดงข้อมูล" : "Display" }}:
    </div>

    <div class="relative w-fit"
    >
      <div class="invisible px-6 py-2 text-sm whitespace-nowrap"
          style="min-height: 40px;"
      >
        {{ pageSize }}
      </div>

      <app-select
        class="absolute top-0 left-0 w-full h-full"
        style="z-index: 2;" 
        [option]="pageSizeOptions"
        [valueIn]="pageSize"
        (valueOut)="onPageSizeChange($event)"
      ></app-select>
    </div>

    <div class="text-sm text-gray-500 whitespace-nowrap">
      {{ language === 'th' ? "ทั้งหมด" : "total" }}: {{ totalItems }}
    </div>
  </div>


    <!-- Right: summary -->
    <div class="text-sm text-gray-600"
    >
      {{ language === 'th' ? "หน้า" : "Page"}} 
      {{ currentPage }} / {{ totalPages }} &middot;
      {{ language === 'th' ? "แสดง" : "Showing"}}
      <span class="font-medium">{{ (currentPage-1)*pageSize.value + 1 }}</span>
      -
      <span class="font-medium">{{ getPageEnd() }}</span>
    </div>

        <!-- Center: page buttons (compact) Small screen -->
    <div class=" items-center space-x-2  w-full" *ngIf="isSmallScreen">

      <!-- page numbers (show a window of pages) -->
      <div class="flex items-center space-x-1 w-full justify-center">
        <ng-container *ngFor="let p of getPageWindow(); let idx = index">
          <button
            (click)="goToPage(p)"
            class="my-theme-custom-table-number-page"
            [class]="p === currentPage ? 'cursor-pointer px-4 py-2 rounded border my-theme-custom-table-pagination text-white text-sm' : 'cursor-pointer px-4 py-2 rounded border border-gray-300 text-sm'"
          >
            {{ p }}
          </button>
        </ng-container>
      </div>

      <!--- next and last buttons Small screen -->
      <div class="flex justify-between items-center mt-2">
        <div class="flex items-center space-x-2">
          <button (click)="first()" [disabled]="currentPage===1"
            class="cursor-pointer px-3 py-2 rounded border border-gray-300 text-sm disabled:opacity-50 my-theme-custom-table-first">
            {{ language === 'th' ? "แรก" : "First"}}
          </button>
          <button (click)="prev()" [disabled]="currentPage===1"
            class="cursor-pointer px-3 py-2 rounded border border-gray-300 text-sm disabled:opacity-50 my-theme-custom-table-prev">
            {{ language === 'th' ? "ก่อนหน้า" : "Prev"}}
          </button>
        </div>

        <div class="flex items-center space-x-2">
          <button (click)="next()" [disabled]="currentPage===totalPages"
            class="cursor-pointer px-3 py-2 rounded border border-gray-300 text-sm disabled:opacity-50 my-theme-custom-table-next">
            {{ language === 'th' ? "ถัดไป" : "Next"}}
          </button>
          <button (click)="last()" [disabled]="currentPage===totalPages"
            class="cursor-pointer px-3 py-2 rounded border border-gray-300 text-sm disabled:opacity-50 my-theme-custom-table-last">
            {{ language === 'th' ? "สุดท้าย" : "Last"}}
          </button>
        </div>
      </div>
    </div>

    <!-- Center: page buttons (compact) Big screen -->
    <div class="flex items-center space-x-2" *ngIf="!isSmallScreen">
      <button (click)="first()" [disabled]="currentPage===1"
        class="cursor-pointer px-3 py-2 rounded border border-gray-300 text-sm disabled:opacity-50 my-theme-custom-table-first">
        <span>{{ language === 'th' ? "แรก" : "First"}}</span>
      </button>
      <button (click)="prev()" [disabled]="currentPage===1"
        class="cursor-pointer px-3 py-2 rounded border border-gray-300 text-sm disabled:opacity-50 my-theme-custom-table-prev">
        <span>{{ language === 'th' ? "ก่อนหน้า" : "Prev"}}</span>
      </button>

      <!-- page numbers (show a window of pages) -->
      <div class="flex items-center space-x-1">
        <ng-container *ngFor="let p of getPageWindow(); let idx = index">
          <button
            (click)="goToPage(p)"
            class="my-theme-custom-table-number-page"
            [class]="p === currentPage ? 'cursor-pointer px-4 py-2 rounded border my-theme-custom-table-pagination text-white text-sm' : 'cursor-pointer px-4 py-2 rounded border border-gray-300 text-sm'"
          >
            {{ p }}
          </button>
        </ng-container>
      </div>

      <button (click)="next()" [disabled]="currentPage===totalPages"
        class="cursor-pointer px-3 py-2 rounded border border-gray-300 text-sm disabled:opacity-50 my-theme-custom-table-next">
        {{ language === 'th' ? "ถัดไป" : "Next"}}
      </button>
      <button (click)="last()" [disabled]="currentPage===totalPages"
        class="cursor-pointer px-3 py-2 rounded border border-gray-300 text-sm disabled:opacity-50 my-theme-custom-table-last">
        {{ language === 'th' ? "สุดท้าย" : "Last"}}
      </button>
    </div>


  </div>

</div>
